/* eslint-disable import/no-anonymous-default-export */
export default (state, action) => {
  switch (action.type) {
    case "SET_PLAYER":
      return {
        ...state,
        player: action.payload,
      };
    case "SET_DURATION":
      return {
        ...state,
        duration: action.payload,
      };
    case "SET_SLIDE_NUMBER":
      return {
        ...state,
        slideNumber: action.payload,
      };
    case "SET_IS_FOLLOWING":
      return {
        ...state,
        isFollowing: action.payload,
      };
    default:
      return state;
  }
};
